import { ref, onMounted, onUnmounted } from 'vue';

export function useSmarticoApi() {
  const smarticoInstance = ref<any>(null); // Renamed to smarticoInstance
  let initInterval: NodeJS.Timeout | null = null;

  const initApi = () => {
    if (window._smartico && window._smartico.api && window._smartico.vapi) {
      // Check for both api and vapi
      smarticoInstance.value = window._smartico; // Assign the entire _smartico object
      if (initInterval) {
        clearInterval(initInterval);
      }
    }
  };

  onMounted(() => {
    if (!smarticoInstance.value) {
      // Use smarticoInstance
      initApi();
      if (!smarticoInstance.value) {
        // Use smarticoInstance
        initInterval = setInterval(initApi, 300);
      }
    }
  });

  onUnmounted(() => {
    if (initInterval) {
      clearInterval(initInterval);
    }
  });

  return {
    smarticoInstance, // Return smarticoInstance
  };
}
